import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { AiFillCamera, AiFillFolderOpen } from "react-icons/ai";
import { useState, useEffect, useRef } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
  RadConnStyle as radStyle,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import styled from "styled-components";
import { FormAuto } from "../../../core/Helper";
import { useDispatch } from "react-redux";
import { setReminder } from "../../../features/UserActions";

export default function StaffPopup(props) {
  console.log(props.fields);

  const dispatch = useDispatch();
  const [dataS, setDataS] = useState(null);
  const [startDate, setStartDate] = useState(new Date());

  const fileInput = useRef(null);
  const fileChooseClick = () => {
    fileInput.current.click();
  };

  const hanndleFileChange = (e) => {
    const formData = new FormData();
    formData.append("user", JSON.stringify(props.fields));
    formData.append("file", e.target.files[0], e.target.files[0].name);

    axios
      .post(
        process.env.REACT_APP_API + "api/staff/SaveFromUpload",
        formData,
        HttpJsonHeader
      )
      .then((res) => {
        props.fields.image_name = res.data;
        props.setStaffImage(process.env.REACT_APP_PHOTO + res.data);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  // show company for selected
  useEffect(() => {
    axios
      .post(
        process.env.REACT_APP_API + "api/staff/getComponents",
        {},
        HttpJsonHeader
      )
      .then((res) => {
        setDataS(res.data);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  }, [props.showEdit]);

  let rowId = props.fields == null ? -1 : props.fields.staffid;
  const handleUpload = (evt) => {};

  const submit = (evt) => {
    evt.preventDefault();
    let data = {
      StaffId: rowId,
      StaffCode: evt.target.oStaffCode.value,
      PrefixId: evt.target.oPrefix.value,
      FirstName: evt.target.oFirstName.value,
      LastName: evt.target.oLastName.value,
      NickName: evt.target.oNickName.value,
      GendId: evt.target.oGender.value,
      StaffTypeId: evt.target.oStaffType.value,
      BrchId: evt.target.oBranch.value,
      LineId: evt.target.oLineId.value,
      MobileNo: evt.target.oMobileNo.value,
      BirthDate: evt.target.oBirthDate.value,
      Email: evt.target.oEmail.value,
      updateby: props.user.userid,
      IsHoldTax: evt.target.oIsHoldTax.checked,
    };

    if (rowId < 0) {
      data = { ...data, createby: props.user.userid };
    }

    console.log("check data.. ", data);

    axios
      .post(
        process.env.REACT_APP_API + "api/staff/update",
        data,
        HttpJsonHeader
      )
      .then((res) => {
        props.setUpdate(true);
        props.hidePopup();
      })
      .catch((err) => console.log(err));
  };

  const DynFIELDS = [
    {
      label: "รหัสเจ้าหน้าที่",
      oName: "oStaffCode",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.staffcode,
      type: "text",
    },

    {
      label: "คำนำหน้า",
      oName: "oPrefix",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.prefixid,
      type: "select",
      rows: dataS ? dataS.Prefix : null,
    },

    {
      label: "ชื่อ",
      oName: "oFirstName",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.firstname,
      type: "text",
    },

    {
      label: "นามสกุล",
      oName: "oLastName",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.lastname,
      type: "text",
    },

    {
      label: "ชื่อเล่น",
      oName: "oNickName",
      require: false,
      defaultValue: props.fields == null ? "" : props.fields.nickname,
      type: "text",
    },

    {
      label: "เพศ",
      oName: "oGender",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.gendid,
      type: "select",
      rows: dataS ? dataS.Gender : null,
    },

    {
      label: "วันเกิด",
      oName: "oBirthDate",
      require: true,
      defaultValue: props.fields == null ? Date() : props.fields.ydm_birthdate,
      type: "date",
      handleChange: (date) => {
        setStartDate(date);
      },
    },

    {
      label: "สาขา",
      oName: "oBranch",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.brchid,
      type: "select",
      rows: dataS ? dataS.Branch : null,
    },

    {
      label: "กลุ่มงาน",
      oName: "oStaffType",
      require: true,
      defaultValue: props.fields == null ? "" : props.fields.stafftypeid,
      type: "select",
      rows: dataS ? dataS.StaffType : null,
    },

    {
      label: "เบอร์มือถือ",
      oName: "oMobileNo",
      require: false,
      defaultValue: props.fields == null ? "" : props.fields.mobile_no,
      type: "text",
    },

    {
      label: "Email",
      oName: "oEmail",
      require: false,
      defaultValue: props.fields == null ? "" : props.fields.email,
      type: "text",
    },

    {
      label: "Line ID",
      oName: "oLineId",
      require: false,
      defaultValue: props.fields == null ? "" : props.fields.line_id,
      type: "text",
    },

    {
      label: "หักภาษี ณ ที่จ่าย",
      oName: "oIsHoldTax",
      require: false,
      defaultValue: props?.fields?.ishold_tax === "y" ?? false,
      type: "checkbox",
    },
  ];

  return (
    <MyModal show={props.showEdit} size="lg" onHide={props.hidePopup} centered>
      <ModalHeaderBlack closeButton>
        <Modal.Title>เพิ่มแก้ไข {props.formName}</Modal.Title>
      </ModalHeaderBlack>

      <ModalBodyBlack style={radStyle.modalBlackBody}>
        <MainPane>
          <LeftPane>
            <FormAuto
              {...{ formId: "form1", items: DynFIELDS, submit: submit }}
            />
          </LeftPane>

          <RightPane>
            <div>
              <ImageBox>
                <ImageObj src={props.staffImage} />
              </ImageBox>
            </div>

            <div>
              <ButtonBox onClick={fileChooseClick}>
                <IconFoloder />
                <ButtonLabel for="file_input">เลือกไฟล์ ..</ButtonLabel>
                <Form id="fUpload" onSubmit={handleUpload}>
                  <InputFile
                    name="file_input"
                    type="file"
                    onChange={hanndleFileChange}
                    ref={fileInput}
                  />
                </Form>
              </ButtonBox>

              <ButtonBox
                onClick={() => {
                  props.setCapture(true);
                }}
              >
                <IconCamera />
                <ButtonLabel>Capture ..</ButtonLabel>
              </ButtonBox>
            </div>
          </RightPane>
        </MainPane>
      </ModalBodyBlack>

      <ModalFooterBlack style={radStyle.modalFooterBlack}>
        <Button variant="primary" type="submit" form="form1">
          Save changes
        </Button>
        <Button variant="danger" onClick={props.hidePopup}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}

const MainPane = styled.div`
  display: flex;
  align-items: center;
`;

const LeftPane = styled.div`
  flex: 1;
  padding: 10px;
  justify-content: center;
`;

const RightPane = styled.div`
  align-self: stretch;
  max-width: 200px;
  display: flex;
  flex-direction: column;
  align-items: top;
  justify-content: center;
  /* background-color: #605a5a; */
  padding: 1px;
`;

const ImageBox = styled.div`
  border-radius: 1%;
  background-image: linear-gradient(20deg, #dedeeb, #f896ee, #e0d8d8);
  box-shadow: 1px 1px 0px 0px #222121;
  overflow: hidden;
`;

// กรอบรูปภาพพนักงาน
const ImageObj = styled.img`
  width: 200px;
  height: 200px;
  opacity: 0.9;
  @media only screen and (max-width: 1000px) {
    width: 100px;
    height: 100px;
  }
`;

const ButtonBox = styled.div`
  width: 200px;
  display: flex;
  margin-top: 5px;
  margin-right: 1px;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
  border-radius: 5%;
  background-image: linear-gradient(#2c2e2d, #211f21);
  &:hover {
    background-image: linear-gradient(#114d06, #0a3523);
  }

  @media only screen and (max-width: 1000px) {
    width: 100px;
    height: 50px;
  }
`;

const InputFile = styled.input`
  display: none;
`;

const IconFoloder = styled(AiFillFolderOpen)`
  height: 32px;
  width: 32px;
  cursor: pointer;
  margin-right: 10px;
  margin-left: 10px;
`;

const IconCamera = styled(AiFillCamera)`
  height: 32px;
  width: 32px;
  cursor: pointer;
  margin-right: 10px;
  margin-left: 10px;
`;

const ButtonLabel = styled.label`
  cursor: pointer;
  display: flex;
  /* background-color:blue; */
  @media only screen and (max-width: 1000px) {
    display: none;
  }
`;
